/**
 * SECRETELLES® — À Propos page styling & link fix.
 * Combines se-about-cache-fix + se-about-link-fix.
 * Runs only on /pages/a-propos-secretelles.
 * Extracted from theme.liquid to reduce global JS overhead.
 */
(function () {
  if (!/\/pages\/a-propos-secretelles/.test(location.pathname)) return;

  function applyStyleFix() {
    // Primary CTA buttons — brand purple
    document.querySelectorAll('.se-story-btn--primary,.se-about-btn--primary').forEach(function (a) {
      a.style.color = '#fff';
      a.style.background = '#5b3a6d';
      a.style.borderColor = '#5b3a6d';
      a.style.textDecoration = 'none';
    });

    // Ghost/outline buttons — brand gold
    document.querySelectorAll('.se-story-btn--ghost,.se-about-btn--ghost').forEach(function (a) {
      a.style.color = '#9b7a35';
      a.style.background = 'rgba(255,255,255,.72)';
      a.style.borderColor = 'rgba(201,168,108,.55)';
      a.style.textDecoration = 'none';
    });

    // Replace broken hero image with fallback
    document.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      if (
        src.indexOf('robe-de-soiree-bicotone-bicotone-238-bicotone-robe-principale-10018121') > -1 ||
        (img.complete && img.naturalWidth === 0 && src.length > 0)
      ) {
        img.src = 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/secretelles-histoire-robe-bleu.jpg?v=1778903812';
        img.alt = 'Robe raffinée Secretelles — élégance féminine moderne';
      }
    });
  }

  function applyLinkFix() {
    // Redirect any stale /collections/nouveautes links to /collections/all
    document.querySelectorAll(
      'a[href="/collections/nouveautes"],a[href$="/collections/nouveautes"]'
    ).forEach(function (a) {
      a.setAttribute('href', '/collections/all');
    });
  }

  function applyAll() {
    applyStyleFix();
    applyLinkFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  // Re-run on load to catch images that load after DOMContentLoaded
  window.addEventListener('load', applyStyleFix);
})();
